import { type AxiosInstance } from "axios";
import { SANSAN_CONNECTION_ENDPOINT } from "@/features/sansanIntegration/api/getConnection";

/**
 * Sansan連携を解除する（`DELETE /sansan/connection/`）。
 */
export const deleteConnection = async (
  apiClient: AxiosInstance
): Promise<void> => {
  await apiClient.delete(SANSAN_CONNECTION_ENDPOINT);
};
